import {Pipe, PipeTransform} from "@angular/core";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";

@Pipe({
    name: 'formattedHeader'
})
export class FormattedHeaderPipe implements PipeTransform {
    constructor (private sanitizer: DomSanitizer) {
    }

    escapeHTML (text: string): string {
        const map = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#039;'
        };

        return text.replace(/[&<>"']/g, function(m) {
            return map[m];
        });
    }

    transform(value: string): SafeHtml {
        const escapedValue = this.escapeHTML(value);
        const formattedValue = escapedValue
            .replace(/\|/g, '<br />')
            .replace(/\[([^\]]+)]/g, '<span class="ph-blue">$1</span>');

        return this.sanitizer.bypassSecurityTrustHtml(formattedValue);
    }
}
